export const SITE_URL = process.env.NEXT_PUBLIC_URL;
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const LS_LANG_KEY = 'i18nextLng';
export const LOCALE_KEY = 'NEXT_LOCALE';
